var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DA537148-51B2-4ACD-8AFA-284891CF86B9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.04378799,0 C9.98722092,0 11.7895644,1.6016473 12.0692855,4.51673328 L12.075,4.63612892 L12.075,6.037 L12.0875,6.0375 C13.1920695,6.0375 14.0875,6.9329305 14.0875,8.0375 L14.0875,14.1 C14.0875,15.2045695 13.1920695,16.1 12.0875,16.1 L2,16.1 C0.8954305,16.1 1.3527075e-16,15.2045695 0,14.1 L0,8.0375 C-1.3527075e-16,6.9329305 0.8954305,6.0375 2,6.0375 L2.012,6.037 L2.0125,4.63612892 L2.01821714,4.5167059 C2.29800173,1.60163277 4.10036446,0 7.04378799,0 Z M7.04378799,2.43173482 C5.31324776,2.43173482 4.54721377,3.09468601 4.37724164,4.69890569 L4.377,6.037 L9.71,6.037 L9.71025836,4.69889123 C9.54032608,3.09467525 8.77432341,2.43173482 7.04378799,2.43173482 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Private"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(3.500000, 2.800000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color-Colors/Semantic/Warning",
    mask: "url(#mask-2)",
    fill: "#F1C250"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.500000, -2.800000)",
    id: "Base"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockGold);
export default __webpack_public_path__ + "static/media/lock-gold.5be42adeda22b96da1643c80a2bde939.svg";
export { ForwardRef as ReactComponent };